
const Point = (x, y) => {
	return {
		type : "point",
		x : x,
		y : y
	}
}

const Bezier = (x, y, bx, by) => {
	return {
		type : "bezier",
		x : x,
		y : y,
		bx : bx,
		by : by,
	}
}


export { Point, Bezier }
